import './PowerBIDashboard.scss';

import { useGetPowerBIConfigQuery } from 'common/queries';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import React from 'react';

interface Props {}

const PowerBIDashboard: React.FC<Props> = (): React.ReactElement => {
  const configQuery = useGetPowerBIConfigQuery();

  return (
    <PowerBIEmbed
      embedConfig={{
        type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
        id: configQuery.data?.report.id,
        embedUrl: configQuery.data?.report.embedUrl,
        accessToken: configQuery.data?.token.token,
        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: true
            }
          },

          background: models.BackgroundType.Transparent
        }
      }}
      cssClassName="PowerBIDashboard"
    />
  );
};

export default PowerBIDashboard;
